<template>
  <div>
    <div class="input-group">
      <input
        :value="modelValue"
        :disabled="disabled"
        :maxlength="maxlength"
        :type="inputType"
        class="form-control"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <div v-if="toggle" class="input-group-append">
        <button class="btn btn-outline-secondary" type="button" @click="togglePasswordVisibility">
          <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" />
        </button>
      </div>
    </div>
    <div v-if="showStrengthMeter && modelValue && modelValue.length >= secureLength" class="mt-2">
      <small class="text-muted">
        Força da senha: <strong :class="strengthTextClass">{{ strengthText }}</strong>
      </small>
      <div class="progress mt-1" style="height: 6px">
        <div
          class="progress-bar"
          :class="strengthClass"
          role="progressbar"
          :style="{ width: (score + 1) * 20 + '%' }"
          :aria-valuenow="(score + 1) * 20"
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import zxcvbn from 'zxcvbn';

export default {
  name: 'PasswordStrength',
  props: {
    modelValue: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    maxlength: { type: Number, default: 20 },
    showStrengthMeter: { type: Boolean, default: true },
    toggle: { type: Boolean, default: false },
    secureLength: { type: Number, default: 8 },
  },
  emits: ['update:modelValue'],
  setup(props) {
    const showPassword = ref(false);

    const inputType = computed(() => {
      return props.toggle && showPassword.value ? 'text' : 'password';
    });

    const score = computed(() => {
      return props.modelValue && props.modelValue.length >= props.secureLength
        ? zxcvbn(props.modelValue).score
        : null;
    });

    const strengthText = computed(() => {
      if (score.value === null) {
        return '';
      }
      return ['Muito fraca', 'Fraca', 'Razoável', 'Forte', 'Muito forte'][score.value];
    });

    const strengthClass = computed(() => {
      if (score.value === null) {
        return '';
      }
      return ['bg-danger', 'bg-warning', 'bg-info', 'bg-primary', 'bg-success'][score.value];
    });

    const strengthTextClass = computed(() => {
      if (score.value === null) {
        return '';
      }
      return ['text-danger', 'text-warning', 'text-info', 'text-primary', 'text-success'][
        score.value
      ];
    });

    const togglePasswordVisibility = () => {
      showPassword.value = !showPassword.value;
    };

    return {
      showPassword,
      inputType,
      score,
      strengthText,
      strengthClass,
      strengthTextClass,
      togglePasswordVisibility,
    };
  },
};
</script>

<style scoped>
.input-group-append .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
